import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AboutUsComponent} from './about-us.component';
import {AboutUsRoutingModule} from './about-us-routing.module';
import {FlexLayoutModule, FlexModule} from '@angular/flex-layout';
import {ContentBackDropModule} from '../@common/back-drop/content-back-drop.module';
import {ResponsiveImageModule} from '../../@modules/responsive-image/responsive-image.module';

@NgModule({
  imports: [
    CommonModule,
    AboutUsRoutingModule,
    ContentBackDropModule,
    FlexModule,
    FlexLayoutModule,
    ResponsiveImageModule,
  ],
  declarations: [AboutUsComponent],
})
export class AboutUsModule {
}
